import { useLoadScript } from '@react-google-maps/api';
import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const libraries: any = ['places'];

export const useGoogleMapApi = () => {
  const { i18n } = useTranslation();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY || '',
    libraries: libraries,
  });

  const getPostCodeByPlaceId = async (placeId: string) =>
    new Promise((resolve, reject) => {
      if (!placeId) reject('placeId not provided');
      try {
        new window.google.maps.places.PlacesService(document.createElement('div')).getDetails(
          { placeId, fields: ['address_components'] },
          (details) => {
            let postcode = null;
            details?.address_components?.forEach((entry) => {
              if (entry.types?.[0] === 'postal_code') {
                postcode = entry.long_name;
              }
            });
            return resolve(postcode);
          },
        );
      } catch (e) {
        reject(e);
      }
    });

  const autocomplete = useRef<any>();

  useEffect(() => {
    if (isLoaded) {
      if (!autocomplete.current) {
        autocomplete.current = new window.google.maps.places.AutocompleteService();
      }
    }
  }, [isLoaded]);

  const getPlacePredictions = async (text: string) => {
    const { predictions } = await autocomplete.current.getPlacePredictions({
      input: text,
      componentRestrictions: { country: ['be', 'fr'] },
      types: ['postal_code', 'sublocality'],
      language: i18n.language,
    });
    return predictions;
  };

  return { isLoaded, getPostCodeByPlaceId, getPlacePredictions };
};
